module.exports = __webpack_public_path__ + "static/media/b3.f1f9f3df.PNG";